module.exports = __webpack_public_path__ + "static/media/3.2862b5a7.jpg";